exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n#registerSourceReport table tr td, #registerSourceReport table tr th{\n    text-align:right;\n}\n", "", {"version":3,"sources":["D:/a/8/s/AFBPlay/src/components/SideMenu/Reports/RegisterSourceReport.vue"],"names":[],"mappings":";AACA;IACI,iBAAiB;CACpB","file":"RegisterSourceReport.vue","sourcesContent":["\n#registerSourceReport table tr td, #registerSourceReport table tr th{\n    text-align:right;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-5dd3b744","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/SideMenu/Reports/RegisterSourceReport.vue
// module id = rNIg
// module chunks = 2